/**
 * Hit / Stand action bar during PLAYER_ACTIONS. Shows this client's own hand
 * total (from `youUpdate`) and sends `hit`/`stand` intents. Locked once the
 * player stands or busts (status from the server). The croupier plays the fixed
 * house hand automatically and has no actions here.
 */

import { useGameStore } from '../state/store';
import { useSend } from '../net/RealtimeProvider';
import { playSfx } from '../audio/sfx';
import { HandView } from './HandView';

export function ActionBar() {
  const send = useSend();
  const phase = useGameStore((s) => s.server.phase);
  const ownHand = useGameStore((s) => s.server.ownHand);
  const identity = useGameStore((s) => s.identity);

  if (phase !== 'PLAYER_ACTIONS' || !ownHand || identity?.role === 'croupier') return null;

  const locked = ownHand.status !== 'playing';

  return (
    <div className="action-bar">
      <div className="action-bar__hand">
        <span className="action-bar__label">Your hand</span>
        <HandView cards={ownHand.hand} />
        <span className="action-bar__total numeric">
          {ownHand.total}
          {ownHand.isSoft ? ' (soft)' : ''}
        </span>
        {ownHand.status === 'bust' && <span className="action-bar__bust">BUST</span>}
        {ownHand.status === 'stood' && <span className="action-bar__stood">STAND</span>}
      </div>
      <div className="action-bar__buttons">
        <button
          type="button"
          className="btn-action btn-hit"
          disabled={locked}
          onClick={() => {
            send({ type: 'hit' });
            playSfx('cardDeal');
          }}
        >
          Hit
        </button>
        <button
          type="button"
          className="btn-action btn-stand"
          disabled={locked}
          onClick={() => {
            send({ type: 'stand' });
            playSfx('chipClink');
          }}
        >
          Stand
        </button>
      </div>
    </div>
  );
}
